import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  addPromoteur,
  uploadPromoteurLogo,
} from "../../../redux/actions/promoteursActions";
import { closeModal } from "../../../redux/actions/modalActions";

const AddPromoteur = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    url: "",
    isEdited: false,
    visibility: true,
    origine: "Novanéa",
    lastSync: new Date().toISOString(),
    logo: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhotoClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));

      setFormData((prev) => ({
        ...prev,
        logo: file,
      }));
    }
  };

  useEffect(() => {
    return () => {
      if (selectedImage) {
        URL.revokeObjectURL(selectedImage);
      }
    };
  }, [selectedImage]);

  const handleAddPromoteur = async () => {
    setIsLoading(true);
    try {
      const result = await dispatch(addPromoteur(formData));

      if (result) {
        setFormData({
          name: "",
          url: "",
          isEdited: false,
          visibility: true,
          origine: "Novanéa",
          lastSync: new Date().toISOString(),
          logo: null,
        });
        setSelectedImage(null);
      }
      dispatch(closeModal());
    } catch (error) {
      console.error("Error adding promoteur:", error);
    }
    setIsLoading(false);
  };

  return (
    <div className="d-flex justify-content-start gap20">
      <div className="d-flex flex-column ">
        <p className="semibold pink fs16">Logo</p>
        <hr />
        <div className="position-relative">
          <img
            src={selectedImage || "./assets/imgNotFound.webp"}
            alt=""
            height={200}
            width={200}
            className="mb-10"
            style={{ objectFit: "contain" }}
          />
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept="image/*"
            style={{ display: "none" }}
          />
          <button
            className="bg-pink radius5 px-20 py-1 white border-0 promoteurChangePhoto"
            onClick={handlePhotoClick}
          >
            Ajouter le logo
          </button>
        </div>
      </div>
      <div className="w100 d-flex flex-column">
        <div>
          <p className="semibold pink fs16">Fiche du promoteur</p>
          <hr />
        </div>
        <div className="d-flex flex-column gap20">
          <div>
            <p className="medium darkGrey fs12 mb-10">Nom</p>
            <input
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w100 customInput"
              placeholder="Nom du promoteur"
            />
          </div>
          <div>
            <p className="medium darkGrey fs12 mb-10 ">URL</p>
            <div className="d-flex align-items-center gap10">
              <input
                name="url"
                value={formData.url}
                onChange={handleInputChange}
                className="w100 customInput"
                placeholder="https://..."
              />
              {formData.url && (
                <a
                  href={formData.url}
                  target="_blank"
                  className="hoverTransition"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/icons/external-link.svg"
                    alt=""
                    height={24}
                    width={24}
                  />
                </a>
              )}
            </div>
          </div>
        </div>
        <button
          className={
            isLoading || formData.name === ""
              ? "bg-soft-grey radius5 px-20 py-1 white border-0 hoverOpacity mt-30"
              : "bg-pink radius5 px-20 py-1 white border-0 hoverOpacity mt-30"
          }
          disabled={isLoading || formData.name === ""}
          onClick={handleAddPromoteur}
        >
          {isLoading ? "Ajout en cours..." : "Ajouter le promoteur"}
        </button>
      </div>
    </div>
  );
};

export default AddPromoteur;
